import React, { useState, useEffect } from 'react';
import "../css/annadaanseva.scss"
import HeaderSection from "../components/common/HeaderSection";
import MetaData from "../helpers/MetaData";
import AnnadaanSevaRegistration from '../components/annadaanseva/AnnadaanSevaRegistration';
import ApiService from "../api/ApiService";
import Guidelines from '../components/annadaanseva/Guidelines';
import { useParams } from 'react-router-dom'

const AnnadaanSeva = () => {
    const { id } = useParams()
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [images, setImages] = useState([]); // Changed to state variable
    const [isLoading, setIsLoading] = useState(true); // Add loading state
    const [showthankyou, setShowthankyou] = useState(false);
    // console.log("showthankyou", showthankyou);

    const [formData, setFormData] = useState({
        fullName: '',
        mobileNo: '',
        emailId: '',
        numberOfPeople: '',
        address: '',
        selectedDate: ''
    });

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [showCalendar, setShowCalendar] = useState(false);

    // Fallback images in case API fails
    const fallbackImages = [
        {
            title: "Annadaan Seva",
            image: "/images/common/SD-5.jpg",
        },
        {
            title: "Annadaan Seva",
            image: "/images/common/SD-19.jpg",
        },
        {
            title: "Annadaan Seva",
            image: "/images/common/SD-13.jpg",
        },
        {
            title: "Annadaan Seva",
            image: "/images/common/SD-14.jpg",
        },
    ];
    const handleShowThankYou = (value) => {
        setShowthankyou(value);
    };
    const fetchAnnadaanSevaImage = async () => {
        try {
            setIsLoading(true);
            const res = await ApiService.fetchAnnadaanSevaImageAll();
            console.log(res);

            // Transform API response to match your existing structure
            if (res && res.images && res.images.length > 0) {
                const transformedImages = res.images.map((imageUrl) => ({
                    title: "Annadaan Seva",
                    image: imageUrl,
                }));
                setImages(transformedImages);
            } else {
                // Use fallback images if API returns no images
                setImages(fallbackImages);
            }
        } catch (error) {
            console.log('Error fetching images:', error);
            // Use fallback images in case of error
            setImages(fallbackImages);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchAnnadaanSevaImage()
    }, [])

    // Auto-advance slider - only start when images are loaded
    useEffect(() => {
        if (!isLoading && images.length > 0) {
            const interval = setInterval(() => {
                setCurrentImageIndex((prevIndex) =>
                    prevIndex === images.length - 1 ? 0 : prevIndex + 1
                );
            }, 4000);

            return () => clearInterval(interval);
        }
    }, [images.length, isLoading]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        alert('Registration submitted successfully!');
    };

    const handleThumbnailClick = (index) => {
        setCurrentImageIndex(index);
    };

    const getDaysInMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    };

    const getFirstDayOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    };

    const formatDate = (date) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };

    const renderCalendar = () => {
        const daysInMonth = getDaysInMonth(selectedDate);
        const firstDay = getFirstDayOfMonth(selectedDate);
        const days = [];
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        // Empty cells for days before the first day of the month
        for (let i = 0; i < firstDay; i++) {
            days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
        }

        // Days of the month
        for (let day = 1; day <= daysInMonth; day++) {
            const isToday = day === new Date().getDate() &&
                selectedDate.getMonth() === new Date().getMonth() &&
                selectedDate.getFullYear() === new Date().getFullYear();

            days.push(
                <div
                    key={day}
                    className={`calendar-day ${isToday ? 'today' : ''}`}
                    onClick={() => {
                        const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), day);
                        setSelectedDate(newDate);
                        setFormData(prev => ({ ...prev, selectedDate: formatDate(newDate) }));
                        setShowCalendar(false);
                    }}
                >
                    {day}
                </div>
            );
        }

        return (
            <div className="calendar-popup">
                <div className="calendar-header">
                    <button
                        type="button"
                        onClick={() => setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1))}
                    >
                        ←
                    </button>
                    <span>{monthNames[selectedDate.getMonth()]} {selectedDate.getFullYear()}</span>
                    <button
                        type="button"
                        onClick={() => setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1))}
                    >
                        →
                    </button>
                </div>
                <div className="calendar-weekdays">
                    <div>Sun</div><div>Mon</div><div>Tue</div><div>Wed</div><div>Thu</div><div>Fri</div><div>Sat</div>
                </div>
                <div className="calendar-days">
                    {days}
                </div>
            </div>
        );
    };

    return (
        <>
            {/* Header Section */}
            <MetaData title="Annadaan Distribution Seva page - ISKCON of Attapur" />
            <HeaderSection title="Annadaan Distribution Seva" desc="Where you will get an opportunity to personally serve and distribute prasadam to the poor and needy." />

            {/* Main Content */}
            <div className="main-content-annadaan">
                <div className="container">
                    <div className="row">
                        {/* Image Section */}
                        {showthankyou ? "" : <div className="col-lg-5">
                            <div className="image-section">
                                {isLoading ? (
                                    <div className="loading-placeholder">
                                        <p>Loading images...</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="image-slider">
                                            <img
                                                src={images[currentImageIndex]?.image}
                                                alt={images[currentImageIndex]?.title}
                                                className="main-image"
                                                onError={(e) => {
                                                    // Fallback if image fails to load
                                                    e.target.src = fallbackImages[currentImageIndex]?.image || fallbackImages[0].image;
                                                }}
                                            />
                                        </div>

                                        {/* <div className="thumbnail-container">
                                            {images.map((image, index) => (
                                                <img
                                                    key={index}
                                                    src={image.image}
                                                    alt={image.title}
                                                    className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                                                    onClick={() => handleThumbnailClick(index)}
                                                    onError={(e) => {
                                                        // Fallback if thumbnail fails to load
                                                        e.target.src = fallbackImages[index]?.image || fallbackImages[0].image;
                                                    }}
                                                />
                                            ))}
                                        </div> */}


                                        <div className="col-12">
                                            <Guidelines />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        }
                        {/* Form Section */}
                        <div className={showthankyou ? "col-lg-12" : "col-lg-7"}>
                            <AnnadaanSevaRegistration
                                bookingid={id}
                                getshowthankyou={handleShowThankYou}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default AnnadaanSeva;